
export class TournamentVO {
    public id: number = 0;
    public name: string;
    public chipsFee: number = NaN;
    public goldFee: number = NaN;
    public status: number = 0;
    public startTime: number = NaN;
    public currentPlayers: number = 0;
    public maxPlayers: number = 0;
    public pot: number = 0;
}
